// project imports
import { Routes } from 'utils/constants';

// assets
import { IconFolders } from '@tabler/icons';

// types
import { NavItemType } from 'models';
import { MenuItemsCA } from 'routes/menu-items/index';

export const USER_MENU_ID = 'users';
export const SUBJECTS_MENU_ID = 'subjects';
export const BALANCE_GROUP_MENU_ID = 'balance-group-detail';
export const DELIVERY_CONTRACTS_MENU_ID = 'deliveryContracts';
export const DEVICES_MENU_ID = 'devices';
export const DELIVERY_POINTS_MENU_ID = 'deliveryPoints';

// ==============================|| EAI MENU ITEMS ||============================== //

const EAIUserMenu = (canAccessUserPage: boolean) => {
  return canAccessUserPage
    ? {
        id: USER_MENU_ID,
        title: 'navigation.eai.users',
        type: 'item',
        url: Routes.EAI.USER_LIST_PATH,
        children: [
          {
            id: 'user-list',
            title: 'navigation.eai.userList',
            type: 'item',
            url: Routes.EAI.USER_LIST_PATH
          },
          {
            id: 'user-detail',
            title: 'navigation.eai.userDetail',
            type: 'item',
            url: Routes.EAI.USER_DETAIL_PATH,
            children: [
              {
                id: 'user-detail-assignment',
                title: 'navigation.eai.userAssignment',
                type: 'item',
                url: Routes.EAI.USER_DETAIL_ASSIGNMENT_PATH
              }
            ]
          },
          {
            id: 'user-wizard',
            title: 'navigation.eai.userWizard',
            type: 'item',
            url: Routes.EAI.USER_CREATE_PATH
          }
        ]
      }
    : {};
};

const EAISubjectsMenu = (canAccessSubjectsPage: boolean) => {
  return canAccessSubjectsPage
    ? {
        id: SUBJECTS_MENU_ID,
        title: 'navigation.eai.subjects',
        type: 'item',
        url: Routes.EAI.SUBJECT_LIST_PATH,
        children: [
          {
            id: 'subject-list',
            title: 'navigation.eai.subjectList',
            type: 'item',
            url: Routes.EAI.SUBJECT_LIST_PATH
          },
          {
            id: 'subject-detail',
            title: 'navigation.eai.subjectDetail',
            type: 'item',
            url: Routes.EAI.SUBJECT_DETAIL_PATH
          },
          {
            id: 'subject-wizard',
            title: 'navigation.eai.subjectWizard',
            type: 'item',
            url: Routes.EAI.SUBJECT_CREATE_PATH
          }
        ]
      }
    : {};
};

const EAIBalanceGroupMenu = (canAccessBalanceGroupPage: boolean) => {
  return canAccessBalanceGroupPage
    ? {
        id: BALANCE_GROUP_MENU_ID,
        title: 'navigation.eai.balanceGroups',
        type: 'item',
        url: Routes.EAI.BALANCE_GROUP_LIST_PATH,
        children: [
          {
            id: 'balanceGroup-list',
            title: 'navigation.eai.balanceGroups',
            type: 'item',
            url: Routes.EAI.BALANCE_GROUP_LIST_PATH
          },
          {
            id: 'balanceGroup-detail',
            title: 'navigation.eai.balanceGroupDetail',
            type: 'item',
            url: Routes.EAI.BALANCE_GROUP_DETAIL_PATH
          }
        ]
      }
    : {};
};

const EAIDeliveryContractMenu = (canAccessDeliveryContractPage: boolean) => {
  return canAccessDeliveryContractPage
    ? {
        id: DELIVERY_CONTRACTS_MENU_ID,
        title: 'navigation.eai.deliveryContracts',
        type: 'item',
        url: Routes.EAI.DELIVERY_CONTRACTS_LIST_PATH,
        children: [
          {
            id: 'delivery-contract-list',
            title: 'navigation.eai.deliveryContracts',
            type: 'item',
            url: Routes.EAI.DELIVERY_CONTRACTS_LIST_PATH
          },
          {
            id: 'delivery-contract-wizard',
            title: 'navigation.eai.deliveryContractWizard',
            type: 'item',
            url: Routes.EAI.DELIVERY_CONTRACTS_CREATE_PATH
          },
          {
            id: 'delivery-contract-detail',
            title: 'navigation.eai.deliveryContractDetail',
            type: 'item',
            url: Routes.EAI.DELIVERY_CONTRACTS_DETAIL_PATH
          }
        ]
      }
    : {};
};

const EAIDevicesMenu = (canAccessDevicePage: boolean) => {
  return canAccessDevicePage
    ? {
        id: DEVICES_MENU_ID,
        title: 'navigation.eai.devices',
        type: 'item',
        url: Routes.EAI.DEVICES_LIST_PATH,
        children: [
          {
            id: 'device-list',
            title: 'navigation.eai.devices',
            type: 'item',
            url: Routes.EAI.DEVICES_LIST_PATH
          },
          {
            id: 'device-detail',
            title: 'navigation.eai.deviceDetail',
            type: 'item',
            url: Routes.EAI.DEVICES_DETAIL_PATH,
            children: [
              {
                id: 'device-detail-deviceGroup',
                title: 'navigation.eai.deviceGroupDetail',
                type: 'item',
                url: Routes.EAI.DEVICES_CHARACTERISTIC_GROUP_DETAIL
              }
            ]
          },
          {
            id: 'device-wizard',
            title: 'navigation.eai.deviceWizard',
            type: 'item',
            url: Routes.EAI.DEVICES_CREATE_PATH
          },
          {
            id: 'device-characteristic-group-wizard',
            title: 'navigation.eai.deviceCharacteristicGroupWizard',
            type: 'item',
            url: Routes.EAI.DEVICES_CHARACTERISTIC_GROUP_CREATE_PATH
          }
        ]
      }
    : {};
};

const EAIDeliveryPointsMenu = (canAccessDeliveryPointPage: boolean) => {
  return canAccessDeliveryPointPage
    ? {
        id: DELIVERY_POINTS_MENU_ID,
        title: 'navigation.eai.deliveryPoints',
        type: 'item',
        url: Routes.EAI.DELIVERY_POINTS_LIST_PATH,
        children: [
          {
            id: 'deliveryPoint-list',
            title: 'navigation.eai.deliveryPointList',
            type: 'item',
            url: Routes.EAI.DELIVERY_POINTS_LIST_PATH
          },
          {
            id: 'deliveryPoint-detail',
            title: 'navigation.eai.deliveryPointDetail',
            type: 'item',
            url: Routes.EAI.DELIVERY_POINTS_DETAIL_PATH,
            children: [
              {
                id: 'deliveryPoint-detail-gds-list',
                title: 'navigation.eai.deliveryPointGdsList',
                type: 'item',
                url: Routes.EAI.DELIVERY_POINT_GDS_LIST_PATH
              },
              {
                id: 'deliveryPoint-detail-gds-detail',
                title: 'navigation.eai.deliveryPointGdsDetail',
                type: 'item',
                url: Routes.EAI.DELIVERY_POINTS_DETAIL_PATH_WITH_GDS_ID
              }
            ]
          },
          {
            id: 'deliveryPoint-wizard',
            title: 'navigation.eai.deliveryPointWizard',
            type: 'item',
            url: Routes.EAI.DELIVERY_POINTS_CREATE_PATH
          }
        ]
      }
    : {};
};

const eai = (menuItemsCA: MenuItemsCA): NavItemType => {
  return {
    id: 'eai',
    title: '',
    type: 'group',
    children: [
      {
        id: 'eai-group',
        title: 'navigation.eai.group',
        type: 'collapse',
        icon: IconFolders,
        children: [
          EAIUserMenu(menuItemsCA.canAccessUserPage),
          EAISubjectsMenu(menuItemsCA.canAccessPartyPage),
          EAIBalanceGroupMenu(menuItemsCA.canAccessBalancingGroupPage),
          EAIDeliveryPointsMenu(menuItemsCA.canAccessDeliveryPointPage),
          EAIDevicesMenu(menuItemsCA.canAccessDevicePage),
          EAIDeliveryContractMenu(menuItemsCA.canAccessDeliveryContractPage)
        ]
      }
    ]
  };
};

export default eai;
